var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "./FieldWithErrorDisplay";
var GenerateReferralLinkModal = /** @class */ (function (_super) {
    __extends(GenerateReferralLinkModal, _super);
    function GenerateReferralLinkModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onCustomBackHalfChange = function (event, data) {
            var val = data.value;
            _this.setState({
                referralCustomBackHalf: val
            });
        };
        _this.submit = function () {
            if (_this.props.referralType === "MARKETING") {
                _this.props.postRequest('/admin/generate-marketing-referral-link', {
                    referralId: {
                        _type: 'MARKETING',
                        id: _this.props.referralId
                    },
                    referralCustomBackHalf: _this.state.referralCustomBackHalf
                });
            }
            else {
                _this.props.postRequest('/user/generate-personal-referral-link', {});
            }
        };
        _this.state = {
            referralCustomBackHalf: ''
        };
        return _this;
    }
    GenerateReferralLinkModal.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            this.props.admin &&
                this.props.referralType === "MARKETING" &&
                React.createElement(React.Fragment, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/customBackHalf', required: true, labelContent: 'Custom Back Half' },
                        React.createElement(Input, { onChange: this.onCustomBackHalfChange }))),
            React.createElement(Button, { disabled: this.state.referralCustomBackHalf.trim() === "" && this.props.referralType === "MARKETING", icon: 'plus', label: 'Get your link', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return GenerateReferralLinkModal;
}(React.PureComponent));
export default GenerateReferralLinkModal;
//# sourceMappingURL=GenerateReferralLinkModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/GenerateReferralLinkModal.js
// module id = 573
// module chunks = 0